import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ProfilePageHeader } from '@sorare/core/src/components/navigation/ProfilePageHeader';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

const ScoutingCenterLayout = () => {
  const {
    flags: { useNewNav = false },
  } = useFeatureFlags();

  return (
    <Wrapper>
      {useNewNav ? (
        <PageHeader text={scoutingCenter.scoutingCenter} disableBackBrowser />
      ) : (
        <ProfilePageHeader />
      )}
      <Outlet />
    </Wrapper>
  );
};

export default ScoutingCenterLayout;
